import { DefaultState } from "features/types";

export type JobSeekersInvitationState = DefaultState & {
  invitation: Invitation;
};

export type Invitation = {
  step: number;
  email: string | null;
  token: string | null;
};

export type JobSeekerSignUpSendCode = {
  email: string;
  token?: string;
};

export type EmailOrPhone = {
  emailOrPhone: string;
};

export type EmailAndPhone = {
  email?: string;
  phone?: string;
};

export interface ProgramAnswer {
  _id?: string;
  questionText: string;
  answerText: string;
}

export type PhoneConfirmationCode = {
  email: string;
  code: string;
  token?: string;
  questionnaire?: ProgramAnswer[];
};

export enum InvitationSteps {
  EMAIL = 0,
  CONFIRMATION_CODE = 1,
}

export enum InvitationType {
  QR = 'QR',
  LINK = 'LINK',
}

export interface ProgramJoinFormData {
  programJoinFormData: ProgramJoinForm;
}

export type ProgramJoinForm = {
  token: any;
  credential?: string;
  organizationLogo?: string;
  programName?: string;
  programDescription?: string;
  programAgreements?: string;
  questionnaire?: ProgramAnswer[];
};

export type ShareLinkInfo = {
  organizationLogo?: string;
  programName: string;
  programDescription?: string;
  programAgreements?: string;
  questionnaire?: ProgramAnswer[];
};

export type ShareLinkInfoResponse = {
  info?: ShareLinkInfo;
  applyLink?: string;
};
